import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-not-found',
  templateUrl: 'not-found.component.html',
  styleUrls: ['not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(@Inject(LOCALE_ID) public locale: string,
              private location: Location) {

  }

  ngOnInit() {
    const absoluteUrl = this.location.path().split('?')[0];
    let toTheTopAnchor = document.getElementById('to_the_top');
    if (toTheTopAnchor) {
      toTheTopAnchor.setAttribute("href", '/' + this.locale + absoluteUrl + '#start');
    }
  }

}
